import Skeleton from 'react-loading-skeleton';
import { useTranslations } from 'next-intl';
import CommonIcon from '@/components/CommonIcon';
import Styles from './index.module.scss';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonDetailPage = () => {
  const t = useTranslations();

  const renderUserInfo = (nameWidth=174, distanceWidth=337) => {
    return (
      <div className={Styles.userInfoWraper}>
        <Skeleton circle key="circle" containerClassName={Styles.skeletonWrapper} className={Styles.avatar} width={48} height={48} />
        <div className={Styles.info}>
          <Skeleton containerClassName={Styles.skeletonWrapper} className={Styles.inlineText} width={nameWidth} height={18} />
          <Skeleton containerClassName={Styles.skeletonWrapper} width={distanceWidth} height={12} />
        </div>
      </div>
    );
  }

  const renderContent = () => {
    const contentSkeletons = [{
      width: 583,
      height: 18,
    }, {
      width: 391,
      height: 18,
    }, {
      width: 722,
      height: 18,
    }];
    return contentSkeletons.map(({width, height}, index) => <Skeleton key={index} containerClassName={Styles.skeletonWrapper} className={Styles.text} width={width} height={height} />)
  }

  const renderTextSkeletons = () => {
    return ['first','second','third'].map((item)=>{
      return <Skeleton key={item} containerClassName={Styles.skeletonWrapper} className={Styles.text} width={268} height={18} />
    })
  };

  const renderAuthorInfoSkeletons = () => {
    return (
      <div className={Styles.authorWrapper}>
        <h3 className={Styles.title}>{t("thread_author_title")}</h3>
        { renderUserInfo(95, 184) }
        <div className={Styles.equipments}>
          <p className={Styles.title}>{t("thread_authenticated_device")}</p>
          <Skeleton containerClassName={Styles.skeletonWrapper} className={Styles.text} width={268} height={18} />
        </div>
        <div className={Styles.latestPosts}>
            { renderTextSkeletons() }
          </div>
      </div>
    )
  }

  const renderHotPostSkeletons = () => {
    return (
      <div className={Styles.hotPostsWrapper}>
        <h5 className={Styles.title}>{t("thread_hot_title")}</h5>
        { renderTextSkeletons() }
      </div>
    )
  }

  const renderMoreAction = () => {
  const actions = ['like', 'collect', 'share', 'extend'];

    return (
      <div className={Styles.moreActionWrapper}>
        {
          actions.map((type)=>{
            return <CommonIcon key={type} className={Styles.icon} icon={type} />
          })
        }
      </div>
    )
  }

  return (
    <div className={Styles.root}>
      <div className={Styles.header} />
      <div className={Styles.main}>
        <div className={Styles.left}>
          <div className={Styles.contentWrapper}>
            <Skeleton containerClassName={Styles.skeletonWrapper} className={Styles.text} width={490} height={18} />
            { renderUserInfo() }
            { renderContent() }
            <Skeleton containerClassName={Styles.skeletonWrapper} className={Styles.image} width={812} height={455} />
            { renderContent() }
            { renderMoreAction() }
          </div>
        </div>
        <div className={Styles.right}>
          { renderAuthorInfoSkeletons() }
          { renderHotPostSkeletons() }
          <Skeleton containerClassName={Styles.skeletonWrapper} className={Styles.bannerAdImage} width={316} height={238} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonDetailPage;

